import { render, staticRenderFns } from "./AttachmentField.vue?vue&type=template&id=2a0d7d7e&scoped=true&"
import script from "./AttachmentField.vue?vue&type=script&lang=js&"
export * from "./AttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentField.vue?vue&type=style&index=0&id=2a0d7d7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d7d7e",
  null
  
)

export default component.exports